<template>
  <div class="content">
    <el-row class="bgW">
      <el-col :span="22">
        <!--检索条件-->
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          <el-form-item label="成交日期">
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              class="w220"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="searchTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="客户名称" v-if="!clienId">
            <el-input
              v-model="search.consignee"
              maxlength="30"
              class="w84"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="手机号" v-if="!clienId">
            <el-input
              class="w120"
              v-model="search.telephone"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="门店名称" v-if="!clienId">
            <el-input
              v-model="search.shop_name"
              maxlength="30"
              class="w84"
              placeholder="请输入"
              clearable
            />
          </el-form-item>

          <el-form-item size="mini" label="护理师(开单人)" prop="sale_id">
            <el-select v-model="search.sale_id" clearable remote filterable placeholder="请选择" class="w140">
              <el-option
                v-for="item in options.staff"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="商品/项目/品项名称" >
            <el-select v-model="search.type" @change="handleTypeChange" clearable class="w100">
              <el-option
                v-for="item in options.typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-select
              v-model="search.kingdee_code"
              clearable
              filterable
              placeholder="请输入"
              class="w220"
              remote
              :remote-method="remoteMethodGoods"
            >
              <el-option
                v-for="item in options.goodsList"
                :key="item.kingdee_code"
                :label="item.name"
                :value="item.kingdee_code"
              >
                <span>{{ item.name }}</span>
                <span style="color: #8492a6; font-size: 13px" v-if="item.spec_name">-{{ item.spec_name}}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="商品/项目名称" >
            <el-select
              v-model="search.goods_id"
              clearable
              remote
              filterable
              placeholder="请输入"
              class="w220"
            >
              <el-option
                v-for="item in options.goodsList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
               <span>{{ item.name }}</span>
                <span style="color: #8492a6; font-size: 13px" v-if="item.spec_name">-{{ item.spec_name}}</span>
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="退款金额">
            <el-input
              v-model="search.low_total"
              maxlength="30"
              class="w84"
              placeholder="最小值"
              clearable
            />
            <span></span>
            <el-input
              v-model="search.large_total"
              maxlength="30"
              class="w84"
              placeholder="最大值"
              clearable
            />
          </el-form-item>
          <el-form-item label="业务类型">
            <el-select v-model="search.business_type" placeholder="请选业务类型" class="w120" clearable>
              <el-option
                v-for="item in options.business_type"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select v-model="search.order_type" placeholder="请选订单类型" class="w120" clearable>
              <el-option
                v-for="item in options.order_type"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model="search.status" placeholder="是否显示作废订单" class="w120" clearable>
              <el-option
                v-for="item in options.display_cannel"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="品项类目选择">
            <el-cascader
              v-model="search.typepx"
              clearable
              :options="options.pxTypeList"
              :props="{ checkStrictly: true }"
            />
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="search.type" placeholder="显示类型" class="w120" >
              <el-option
                v-for="item in options.type"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
      </el-col>
    </el-row>
    <div class="accountCon">
      <div class="btnBox">
        <el-button
          v-loading.fullscreen.lock="fullscreenLoading"
          type="primary"
          class="mb10"
          size="mini"
          @click="tapBtn('export')"
        >导出数据</el-button>
        <el-button
          v-loading.fullscreen.lock="fullscreenLoading"
          type="primary"
          class="mb10"
          size="mini"
          @click="tapBtn('allExport')"
        >退货导出数据</el-button>
        <div v-if="userInfo.shop_id"></div>
        <!-- <el-button
          v-if="!clienId"
          type="primary"
          class="mb10"
          size="mini"
          @click="tapBtn('lock')"
        >锁定订单</el-button> -->
        <span v-if="is_show_add">
          <el-button
            type="primary"
            v-if="clienId && oldId == clienId"
            round
            class="mb10"
            size="mini"
            @click="tapBtn('goods')"
          >添加退货订单</el-button>
        </span>

      </div>
      <!--列表-->
      <el-row>
        <el-col :span="24">
          <el-table
            v-loading="table_loading"
            :data="flatList"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
            @selection-change="handleSelectionChange"
            row-key="_rowKey"
            :span-method="spanMethod"
          >
            <ElTableColumn label="订单编号" prop="refund_order_no" width="160" fixed="left"/>
            <ElTableColumn label="成交日期" prop="deal_time" width="95" fixed="left" />
            <ElTableColumn label="客户名称" prop="consignee" fixed="left"/>
            <ElTableColumn label="手机号" prop="telephone" width="95" />
            <ElTableColumn label="客户K3代码" prop="king_no" width="95" />
            <ElTableColumn label="门店" prop="shop_name" />
            <ElTableColumn label="开单人" prop="sale_name" />
            <ElTableColumn label="业务类型">
              <template slot-scope="{ row }">
                <div>{{ row.business_type }}</div>
              </template>
            </ElTableColumn>
            <ElTableColumn label="订单类型" prop="order_type" />
            <ElTableColumn label="退款金额" prop="total_amount" />
            <ElTableColumn label="商品名称" prop="goods_name" width="160" />

            <ElTableColumn label="别名">
              <template slot-scope="{ row }">
                <span>{{ row.goods_alias_name || '-' }}</span>
              </template>
            </ElTableColumn>
            <ElTableColumn label="商品类型" prop="data_business_type_text" />
            <ElTableColumn label="品项" >
              <template slot-scope="{ row }">
                <span>
                  {{ row.type_one_name ? row.type_one_name + '/' : '' }}
                  {{ row.type_two_name ? row.type_two_name + '/' : '' }}
                  {{ row.type_three_name || '-' }}
                </span>
              </template>
            </ElTableColumn>

            <ElTableColumn label="销售单价" prop="pay_price" />
            <ElTableColumn label="退货数量" prop="return_num" />
            <ElTableColumn label="退货金额">
              <template slot-scope="{ row }">
                <span>{{ (Number(row.refund_principal_price) + Number(row.gift_price) + Number(row.shop_transfer_price)) | toFixed2 }}</span>

              </template>
            </ElTableColumn>
            <ElTableColumn label="是否退预存货" prop="is_refund_prestock" />
            <ElTableColumn label="退预存货数量">
              <template slot-scope="{ row }">
                <span>{{ row.takeout_stock_num || '-' }}</span>
              </template>
            </ElTableColumn>
            <ElTableColumn label="订单状态" prop="status_msg" />
            <!-- <ElTableColumn label="是否锁定">
              <template slot-scope="{ row }">
                <span>{{row.is_lock == 0?'未锁定':'已锁定'}}</span>
              </template>
            </ElTableColumn> -->
            <ElTableColumn label="操作" fixed="right" v-if="oldId == clienId">
              <template slot-scope="{ row }">
                <span class="theme" v-if="clienId && row.goods_list" @click="tapBtn('客户退货详情',row)">查 看</span>
                <span class="theme"  v-if="!clienId && row.goods_list" @click="tapBtn('退货详情',row)">查 看</span>
              </template>
            </ElTableColumn>
          </el-table>
          <div class="reveal" v-if="sum_amount != 'noShow'">
            <span class="mr20">
              退货金额合计：
              <span class="peril">{{sum_amount}}</span>
            </span>
          </div>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { searchPersonList } from '@/api/staff'
import { mapGetters } from "vuex";
import dateMixin from '@/mixins/dateMixin';
import pagination from "@/components/Pagination";
import { goodsList2,getGoodsAndItem,getGoodList,getProductTypeParent} from '@/api/goods'
import { refundList, refundExport, lockOrderR,refundOneOrderList,refundAllExport,refundOneOrderExport } from "@/api/order";
import { convertToTreeData } from '@/utils/constants';
class Page {
  total = 0;
  page = 1;
  limit = 10;
}
class Search {
  typepx = [];
  kingdee_code = "";
  sale_id = "";
  status = 1;
  goods_id = "";
  telephone = "";
  start_time = "";
  end_time = "";
  consignee = "";
  shop_name = "";
  low_total = "";
  large_total = "";
  business_type = "";
  order_type = "";
  display_cannel = 1;
  type = 1;
}
class Options {
  goodsList = [];
  pxTypeList = [];
  typeList =[
    { id: 1, name: '品项' },
    { id: 2, name: '商品' },
    { id: 3, name: '服务' }
  ];
  staff=[];
  business_type = [
    { id: 1, name: "疤痕" },
    { id: 2, name: "项目" }
  ];
  order_type = [
    { id: 1, name: "新单" },
    { id: 2, name: "补单" }
  ];
  display_cannel = [
    // { id: 0, name: "不显示" },
    // { id: 1, name: "显示" }
    { id: 1, name: "未作废" },
    { id: 4, name: "已作废" }
  ];
  type = [
    // { id: 0, name: "不显示" },
    // { id: 1, name: "显示" }
    { id: 1, name: "退货单" },
    { id: 2, name: "单品退" }
  ];
}
export default {
  name: "OrderList",
  mixins: [dateMixin],
  components: {
    pagination
  },
  filters: {
  toFixed2(val) {
    return Number(val).toFixed(2)
  },
},
  props: {
    clienId: {
      type: String,
      default: ""
    },
    detail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fullscreenLoading: false,
      table_loading: false,
      search: new Search(), // 检索条件
      options: new Options(), // 选项
      page: new Page(), // 分页
      list: [], // 数据展示
      idList: "",
      oldId:"",
      value1: [],
      sum_amount: "noShow",
      is_show_add:true
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    flatList() {
      return this.flattenList(this.list);
    },
    orderSpanMap() {
      return this.buildOrderSpanMap(this.flatList);
    }
  },
  mounted() {
    if(this.clienId){
      this.oldId = this.$route.query.id.toString()
    }else{
      this.setDefaultDate();
    }

    this.getList();
    this.getGoods();
  },
  methods: {
    flattenList(orderList) {
      const result = [];
      orderList.forEach(order => {
        if (order.goods_list && order.goods_list.length > 0) {
          order.goods_list.forEach((goods, index) => {
            result.push({
              ...order,
              goods_name: goods.goods_name || goods.name || '-',
              goods_alias_name: goods.goods_alias_name || goods.alias_name || '-',
              data_business_type_text: goods.data_business_type_text,
              type_one_name: goods.type_one_name || '-',
              type_two_name: goods.type_two_name || '-',
              type_three_name: goods.type_three_name || '-',
              pay_price: goods.pay_price || 0,
              return_num: goods.return_num || goods.number || 1,
              refund_principal_price: goods.refund_principal_price,
              gift_price: goods.gift_price,
              shop_transfer_price: goods.shop_transfer_price,
              is_refund_prestock: goods.is_refund_prestock,
              takeout_stock_num: goods.takeout_stock_num,
              _rowKey: order.id + '_' + (goods.id || index)
            });
          });
        } else {
          result.push({
            ...order,
            goods_name: '-',
            pay_price: '-',
            return_num: '-',
            goods_alias_name: '-',
            type_one_name: '-',
            type_two_name: '-',
            type_three_name: '-',
            _rowKey: order.id + '_empty'
          });
        }
      });
      return result;
    },
    buildOrderSpanMap(flatData) {
      const map = {};
      let currentOrderId = null;
      let startIndex = 0;
      flatData.forEach((item, index) => {
        const orderId = item.id;
        if (orderId !== currentOrderId) {
          if (currentOrderId !== null) {
            map[currentOrderId] = {
              start: startIndex,
              end: index - 1,
              count: index - startIndex
            };
          }
          currentOrderId = orderId;
          startIndex = index;
        }
      });
      if (currentOrderId !== null && flatData.length > 0) {
        map[currentOrderId] = {
          start: startIndex,
          end: flatData.length - 1,
          count: flatData.length - startIndex
        };
      }
      return map;
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      // 需要合并的列下标：0订单编号，1成交日期，2客户名称，3手机号，4客户K3代码，5门店，6开单人，7业务类型，8订单类型，9退款金额，19订单状态，20操作
      const mergeCols = [0,1,2,3,4,5,6,7,8,9,19,20];
      const info = this.orderSpanMap[row.id];
      if (!info) return { rowspan: 1, colspan: 1 };
      if (!mergeCols.includes(columnIndex)) {
        return { rowspan: 1, colspan: 1 };
      }
      if (rowIndex === info.start) {
        return { rowspan: info.count, colspan: 1 };
      } else {
        return { rowspan: 0, colspan: 0 };
      }
    },
    handleTypeChange(val){
      this.search.kingdee_code = ""
      if(val == 1){
        this.remotePxMethod('');
      }else if(val == 2){
        this.remoteSpMethod('');
      }else if(val == 3){
        this.remoteFwMethod('');
      }

    },
    remoteMethodGoods(query){
      console.log("1111111111111111111" )
      if( this.search.type == 1){
        this.remotePxMethod(query);
      }else if(this.search.type == 2){
        this.remoteSpMethod(query);
      }else if(this.search.type == 3){
        this.remoteFwMethod(query);
      }
    },
    remoteSpMethod(query) {
      getGoodList({ type:2,action:'search',name: query }).then(res=>{
        this.options.goodsList = res;
      })
    },
    remoteFwMethod(query) {
      getGoodList({ type:3,action:'search',name: query }).then(res=>{
        this.options.goodsList = res;
      })
    },
    remotePxMethod(query) {
      getGoodList({ type:1, shop_id:this.userInfo.shop_id,name: query,action:'search'}).then(res=>{
        this.options.goodsList = res;
      })
    },    

    getGoods () {
      // goodsList2({ page: 1, limit: 100000 }).then(
      //   res => {
      //     this.options.goodsList = res.list
      //   }
      // )
      // getGoodsAndItem().then(
      //   res => {
      //     this.options.goodsList = res
      //   }
      // )
        searchPersonList().then(
        res => {
          this.options.staff = res
        }
        
        )
        getProductTypeParent({ level : 'three' }).then(res => {
            this.options.pxTypeList  = convertToTreeData(res.data);
          })
    },
    // 获取列表
    getList(option) {
      this.table_loading = true
      if (option == "search") this.page = new Page();
        if(this.search.type == 1){
          refundList({
              ...this.search,
              type_one: this.search.typepx[0] || '',
              type_two: this.search.typepx[1] || '',
              type_three: this.search.typepx[2] || '',
              ...this.page,
              type: 2,
              uid: this.clienId ? this.clienId : "",
            }).then(res => {
              this.table_loading = false
              this.is_show_add = res.is_show_add
              this.list = res.list;
              this.page.total = res.dataCount;
              if (this.search.end_time) {
                this.sum_amount = res.sum_amount;
              } else {
                this.sum_amount = "noShow";
              }
            });
        }else{
          //单品退
          refundOneOrderList({
              ...this.search,
              type_one: this.search.typepx[0] || '',
              type_two: this.search.typepx[1] || '',
              type_three: this.search.typepx[2] || '',
              ...this.page,
              type: 2,
              uid: this.clienId ? this.clienId : "",
            }).then(res => {
              this.table_loading = false
              this.is_show_add = res.is_show_add
              this.list = res.list;
              this.page.total = res.dataCount;
              if (this.search.end_time) {
                this.sum_amount = res.sum_amount;
              } else {
                this.sum_amount = "noShow";
              }
            });
        }
    
    },
    // 日期搜索
    searchTime(val) {
      if (val) {
        this.search.start_time = val[0];
        this.search.end_time = val[1];
      } else {
        this.search.start_time = "";
        this.search.end_time = "";
      }
    },
    // 点击详情
    tapBtn(type, row) {
      switch (type) {
        case "退货详情":
          if(row.type ==5){
            //单品退
            this.$router.push(
              "./refundOneDetail?id=" + row.id
            );
          }else{
            this.$router.push(
              "./refundDetail?id=" + row.id + "&type=" + row.type
            );
          }
          
          break;
        case "客户退货详情":
          
          const queryT = {
            id: row.id,
            activeName: "second1",
            activeTab: "returnList",
            clienId: this.clienId,
            type: row.type,
            detail: this.detail
          };
           if(row.type ==5){
            this.$router.push({ name: "单品退订单-详情", query: queryT });
          }else{
              this.$router.push({ name: "退/收单详情", query: queryT });
          }
          break;
        case "goods":
          const querys = { detail: this.detail };
          this.$router.push({ name: "添加退货订单", query: querys });
          break;
        case "export":
          this.hint("导出选中列表", "export");
          break;
        case "allExport":
          this.hint("导出退货、单品退列表", "allExport");
          break;
        case "lock":
          if (this.search.end_time) {
            this.hint("锁定选中条件的订单", "lock");
          } else {
            this.$message({
              message: "请选择锁定日期",
              type: "warning"
            });
          }
          break;
      }
    },
    // 提示
    hint(text, type) {
      this.$confirm(`${text},是否确定？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (type == "allExport") {
            this.getAllExport();
          }
          else if (type == "export") {
            this.getExport();
          } else {
            this.getLockOrder();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    //锁单
    getLockOrder() {
      lockOrderR({ ...this.search, type: 2 }).then(res => {
        this.$message({
          message: res.msg,
          type: "success"
        });
        this.getList();
      });
    },
    // 导出
    getExport() {
        this.fullscreenLoading = true
        if(this.search.type == 1){
          //退货单--导出
          refundExport({
            ...this.search,
            type_one: this.search.typepx[0] || '',
            type_two: this.search.typepx[1] || '',
            type_three: this.search.typepx[2] || '',
            type: 2,
            uid: this.clienId ? this.clienId : "",
          }).then(res=>{
            window.open(res.data.url);
            this.fullscreenLoading = false
          })
        }else{
          //单品退订单--导出
          refundOneOrderExport({
            ...this.search,
            type_one: this.search.typepx[0] || '',
            type_two: this.search.typepx[1] || '',
            type_three: this.search.typepx[2] || '',
            type: 2,
            uid: this.clienId ? this.clienId : "",
          }).then(res=>{
            window.open(res.data.url);
            this.fullscreenLoading = false
          })
        }
        
    //    refundExport({ id: this.idList, type: 2 }).then(res => {
    //    window.open(res.data.url);
    // });
    },
     // 导出
     getAllExport() {
        this.fullscreenLoading = true
        
          refundAllExport({
            ...this.search,
            type_one: this.search.typepx[0] || '',
            type_two: this.search.typepx[1] || '',
            type_three: this.search.typepx[2] || '',
            type: 2,
            uid: this.clienId ? this.clienId : "",
          }).then(res=>{
            window.open(res.data.url);
            this.fullscreenLoading = false
          })
    //    refundExport({ id: this.idList, type: 2 }).then(res => {
    //    window.open(res.data.url);
    // });
    },
    // 改变表格选中状态
    handleSelectionChange(val) {
      this.idList = val.map(i => {
        return i.id;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.accountCon {
  background: #fff;
  padding: 10px 0px 80px;
  .btnBox {
    display: flex;
    column-gap: 10px;  }
}
.reveal {
  text-align: right;
  padding: 20px 0;
  .peril {
    font-weight: bold;
  }
}
</style>
